import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PdaComponent } from './pda.component';

const routes: Routes = [
  {
    path: '',
    component: PdaComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PdaRoutingModule {}
